import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { Group, GroupUser, GroupUserMembership, UserRolesByBuilding } from "../types/group.type";

export const createGroupQueries = (api: CoreApiClient) => {
  const { client } = api;

  const list = async (): Promise<Group[]> => {
    const { data, error } = await client.GET("/groups");
    if (error) throw new Error(error.message);
    return data;
  };

  const users = async (groupId: string): Promise<GroupUser[]> => {
    const { data, error } = await client.GET("/groups/{groupId}/users", {
      params: { path: { groupId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  const userRoles = async (groupId: string, userId: string): Promise<UserRolesByBuilding[]> => {
    const { data, error } = await client.GET("/groups/{groupId}/users/{userId}", {
      params: { path: { groupId, userId } },
    });
    if (error) throw new Error(error.message);
    return data;
  };

  const userMembership = async (groupId: string, email: string): Promise<GroupUserMembership | null> => {
    const { data, error } = await client.GET("/groups/{groupId}/users/membership", {
      params: { path: { groupId }, query: { email } },
    });
    if (error) throw new Error(error.message);
    // oxlint-disable-next-line typescript/no-unnecessary-condition
    return data ?? null;
  };

  return {
    list,
    users,
    userRoles,
    userMembership,
    queries: createQueryKeys("group", {
      all: {
        queryKey: null,
        queryFn: list,
      },
      users: (groupId: string) => ({
        queryKey: [groupId, "users"],
        queryFn: () => users(groupId),
      }),
      userRolesByBuilding: (groupId: string, userId: string) => ({
        queryKey: [groupId, userId, "roles"],
        queryFn: () => userRoles(groupId, userId),
      }),
      userMembership: (groupId: string, email: string) => ({
        queryKey: [groupId, "membership", email],
        queryFn: () => userMembership(groupId, email),
      }),
    }),
  };
};
